/**
 * Where each kind of account lives: its home page and its login page.
 * Used by the router guard, login pages, logout buttons and the POS so they
 * all agree (Restora owners must never land on the Madentak login, POS staff
 * never on the owner login, …).
 */
import { posHomePath } from '@/lib/posPermissions'

const LS = (k) => {
  try {
    return localStorage.getItem(k) || ''
  } catch {
    return ''
  }
}

export function isLmenusOwner() {
  return LS('role') === 'business_owner' && (LS('lmenus') === 'true' || LS('city') === 'virtual')
}

export function ownerHome() {
  return isLmenusOwner() ? '/business/home' : '/business/my-data'
}

/** Home page for the signed-in account ('' when nobody is signed in). */
export function homeFor(role = LS('role')) {
  switch (role) {
    case 'super_admin':
    case 'admin':
    case 'office':
      return '/Order'
    case 'business_owner':
      return ownerHome()
    case 'pos_staff':
      return posHomePath(LS('posRole'))
    default:
      return ''
  }
}

/** Login page for an account kind (the current one by default). */
export function loginFor(role = LS('role'), { lmenus = isLmenusOwner() } = {}) {
  if (role === 'pos_staff') {
    const r = LS('entityId')
    return r ? `/pos/login?r=${encodeURIComponent(r)}` : '/pos/login'
  }
  if (role === 'business_owner' && lmenus) return '/gusto/login'
  return '/login'
}
